import { Component, ViewChild, ElementRef, Input, EventEmitter, Output, OnInit } from '@angular/core';

@Component({
  selector: 'mode-field-description-view',
  templateUrl: './field-description-view.component.html',
  styleUrls: ['./field-description-view.component.scss'],
})
export class FieldDescriptionViewComponent implements OnInit {
  @Input() description = '';
  @Input() readOnly = false;
  @Output() toggleEditable = new EventEmitter<void>();
  @ViewChild('readOnlyEditor') readOnlyEditor!: ElementRef;

  placeholderText = '';
  showIcon = false;
  dsGray800 = '';
  viewOnlyHTML = '';

  ngOnInit(): void {
    this.placeholderText = this.createPlaceHolderText();
    this.viewOnlyHTML = this.getViewOnlyHTML();
  }

  hasDescription(): boolean {
    return !!this.description && this.description.length > 0;
  }

  createPlaceHolderText(): string {
    return this.readOnly ? '' : `Double-click to ${this.hasDescription() ? 'edit' : 'add'} description`;
  }

  getViewOnlyHTML(): string {
    if (this.hasDescription()) {
      return this.description;
    } else {
      return `<span>${this.placeholderText}</span>`;
    }
  }

  toggleIcon(): void {
    if (!this.readOnly) {
      this.showIcon = !this.showIcon;
    }
  }
}
